module.exports = __webpack_public_path__ + "static/teegan_dt-682d2d56ae7a5161a3d95774505d467b.jpg";